import { app, router } from './app';
import './assets/sass/main.scss';

if (import.meta.hot) {
  import.meta.hot.accept();
}
router.isReady().then(() => {
  app.mount('#app');
});
